module.exports = __webpack_public_path__ + "static/img/parameter2.e2b92a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/parameter2.png
// module id = LWZE
// module chunks = 2